<div class="modal__header">
  <div class="modal__title reference-sheet-upload-popup-header">
    UPLOAD CUSTOM AUTONORM MAPPINGS FILE
  </div>
</div>
<div class="modal__content reference-sheet-upload-popup-text">
  @if (!existingFileName) {
    <div>
      <span>No existing custom autonorm mappings exist, please upload below</span>
    </div>
  }
  @if (existingFileName) {
    <div>
      <span class="bold">Current Reference File: </span>
      <div>
        <button class="btn delete-existing-document-button" (click)="deleteExistingReferenceSheetUpload()"><i class="fas fa-trash"></i></button><a (click)="downloadReferenceSheet()">{{existingFileName}}</a>
      </div>
    </div>
  }
  <hr>
    <div>
      <div>
        <span class="bold">Upload a new reference file</span>
      </div>
      <input #uploadInput type="file" id="actual-btn" class="hidden" ng2FileSelect [uploader]="uploader" accept=".csv,.xls,.xlsx"/>
      <button class="btn btn-primary" (click)="openFilePicker()">Choose File</button>
      <span id="file-chosen" class="file-selector-label">{{getFileChosenText()}}</span>
      <div>
        @if (invalidFileType) {
          <span class="invalid-file-type-text">Invalid file type. Please select a CSV or Excel file (.csv, .xls, .xlsx) to upload.</span>
        }
      </div>
    </div>
  </div>

  <div class="modal__footer">
    <button type="reset" class="btn btn-link" (click)="close()">Close</button>
    <button class="btn btn-primary" [disabled]="!fileQueuedForUpload" (click)="uploadDocument()">Upload</button>
  </div>


